<template>
  <div>
    <v-card class="pa-2 ma-2">
      <v-card-title class="headline">Тезисы
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" text @click="get_thesis_doc()">скачать в *.doc</v-btn>
      </v-card-title>

        <v-row>
              <v-card-text style="text-align: center; font-size: 16px;">
                <b>{{ thesis.name }}</b>
              </v-card-text>

              <v-card-text style="text-align: center; font-size: 16px;">
                <u><b>{{ thesis.author.fio }}</b></u>
                <sup v-if="thesis.orgs && thesis.orgs.length > 1">
                  <b v-if="thesis.author.thesisorgs_ids && thesis.author.thesisorgs_ids.length > 0"> {{ org_order_text(thesis.author.thesisorgs_ids) }}</b>
                </sup>
                <b v-for="co in thesis.coautors">, {{ co.fio }}
                  <sup v-if="thesis.orgs && thesis.orgs.length > 1">
                    <b v-if="co.thesisorgs_ids && co.thesisorgs_ids.length > 0"> {{ org_order_text(co.thesisorgs_ids) }}</b>
                  </sup>
                </b>
              </v-card-text>
              <v-card-text v-if="thesis.orgs" class="pa-0" v-for="org, id in thesis.orgs" style="text-align: center; font-size: 14px;" :key="'orgs_'+id">
                <p class="mb-0" mstyle="font-style: italic;">
                  <sup v-if="thesis.orgs.length > 1">{{ org.order_id }}</sup>{{ org.descr }}<i v-if="org.order_id == 1"  style="font-style: italic;">, {{ thesis.email }}</i>
                </p>
              </v-card-text>

              <v-card-text v-html="view_thesis" style="text-indent: 20px; text-align: justify;"></v-card-text>
              <!-- <p>
                {{ view_thesis }}
              </p> -->
              <v-card-text  style="text-indent: 20px; text-align: justify;">
                {{ thesis.finance }}
              </v-card-text>

              <v-card-text style="text-align: center; font-size: 16px;" class="pb-0">
                <b>Литература</b>
              </v-card-text>
              <v-card-text class="pa-0" v-for="lit_descr,id in thesis.lit" :key="id" style="text-indent: 20px; text-align: justify;font-size: 12px;">
                <p v-if="lit_descr && lit_descr.length > 0" class="mb-0">{{ (id+1).toString() }}. {{ lit_descr }}</p>            
              </v-card-text>
           
              <v-card-text>
                <p></p>
              </v-card-text>

        </v-row>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" text @click="$emit('closeDialog', -1)">закрыть</v-btn>
      </v-card-actions>

    </v-card>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
  mounted() {
    this.update_data()
  },
  name: 'ThesisShow',

  props: {
    thesis_data: [Array, Object]
  },

  data: () => ({
    loading: false,
    thesis: {
      name: '',
      text: '',
      finance: '',
      email: '',
      lit: '',
      coautors: [],
      author: {
        fio: '', 
        org: '', 
        id: 0,
        org_id: 0
      }
    },
    orgs_count: 1,
    authors_count: 1,
    view_thesis: '',
  }),

  components: {
  },

  watch: {
    thesis_data(val){
      this.update_data()
    },

    'thesis.text'(val){
      var str = this.thesis.text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .replace(/`/g, '&#x60;')
        .replaceAll('&lt;i&gt;','<i style="font-style: italic;">')
        .replaceAll('&lt;/i&gt;','</i>')
      this.view_thesis = '<p style="margin-bottom: 0px">' +  str.replace(/\n/g,'</p><p style="margin-bottom: 0px">') + '</p>'
    },
  },

  computed: {
    ...mapGetters([
    ]),
  },

  created() {
  },

  methods: {
    ...mapActions([
      'UPLOAD_THESIS', 'UPLOAD_THESIS_TO_DOCX'
    ]),
    ...mapMutations([
      'UPDATE_OVERLAY',
    ]),

    update_data(){
      this.thesis = this.thesis_data
      // console.log('this.thesis ', this.thesis)
    },

    org_order_text(ids){
      var res = ''
      ids.forEach((user_org_id, count) => {
        this.thesis.orgs.forEach((org, count) => {
          if(org.id == user_org_id){
            res = res + ',' + org.order_id
          }
        })
      })
      return res.slice(1)
    },

    get_thesis_doc(){
      this.UPDATE_OVERLAY(true)
      this.UPLOAD_THESIS_TO_DOCX({id: this.thesis.id, type_filter: 0})
        .then((res) => {
          this.UPDATE_OVERLAY(false)
        })
        .catch((e) => this.UPDATE_OVERLAY(false));
    },

  }

};
</script>
